export { PLANNED_ORDER_SERVICE_JOB as NAME, DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtServiceJobDetails';
